var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44 22.5C44 34.3741 34.3741 44 22.5 44C10.6259 44 1 34.3741 1 22.5C1 10.6259 10.6259 1 22.5 1C34.3741 1 44 10.6259 44 22.5Z",
    stroke: "#00A4FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3372 23.8029C23.9391 24.0683 23.4767 24.2086 23 24.2086C22.5233 24.2086 22.0609 24.0683 21.6629 23.8029L15.1065 19.4319C15.0702 19.4076 15.0347 19.3824 15 19.3564V26.5188C15 27.3399 15.6664 27.9917 16.4729 27.9917H29.5271C30.3482 27.9917 31 27.3253 31 26.5188V19.3563C30.9652 19.3824 30.9297 19.4077 30.8932 19.432L24.3372 23.8029Z",
    fill: "#00A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6266 18.6518L22.1829 23.0229C22.4311 23.1883 22.7155 23.2711 23 23.2711C23.2844 23.2711 23.5689 23.1883 23.8171 23.0229L30.3734 18.6518C30.7658 18.3904 31 17.9529 31 17.4807C31 16.6688 30.3395 16.0083 29.5276 16.0083H16.4724C15.6605 16.0083 15 16.6688 15 17.4815C15 17.9529 15.2342 18.3904 15.6266 18.6518Z",
    fill: "#00A4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f729fa75221b3d747c08188b731660b6.svg";
export { ForwardRef as ReactComponent };